import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './career-saved-component.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var CareerSavedComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareerSavedComponent, _super);
    function CareerSavedComponent(element) {
        return _super.call(this, element) || this;
    }
    CareerSavedComponent.prototype.init = function () {
        var _this = this;
        this.containerLoader = this.element.querySelector('.career-saved-component__loader');
        this.containerItems = this.element.querySelector('.career-saved-component__results');
        this.containerEmpty = this.element.querySelector('.career-saved-component__empty');
        this.containerButtons = this.element.querySelector('.career-saved-component__buttons');
        this.containerButtonsAll = this.element.querySelector('.career-saved-component__buttons--all');
        this.containerButtonsSelected = this.element.querySelector('.career-saved-component__buttons--selected');
        this.buttonRemoveAll = this.element.querySelector('.js-var-button-remove-all');
        this.buttonRemoveSelected = this.element.querySelector('.js-var-button-remove-selected');
        if (this.element.getAttribute('data-detail-url')) {
            this.attributeDetailPage = this.element.getAttribute('data-detail-url');
        }
        if (localStorage.getItem('sbgCareersSaved')) {
            this.storageCareers = localStorage.getItem('sbgCareersSaved');
        }
        else {
            this.storageCareers = JSON.stringify([]);
        }
        $(document).on('click', 'input.js-selected-jobs', function (e) {
            _this.detectCheckboxesSelected();
        });
        this.onload();
    };
    CareerSavedComponent.prototype.bindEvents = function () {
        var _this = this;
        this.buttonRemoveAll.addEventListener('click', function (event) {
            localStorage.removeItem('sbgCareersSaved');
            _this.containerItems.classList.add('d-none');
            _this.containerButtons.classList.add('d-none');
            _this.containerEmpty.classList.remove('d-none');
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
        this.buttonRemoveSelected.addEventListener('click', function (event) {
            var storage = JSON.parse(_this.storageCareers);
            var IDs = [];
            $('input.js-selected-jobs').each(function (index, item) {
                if ($(item).is(':checked')) {
                    IDs.push($(item).val());
                }
            });
            for (var iStorage = 0; iStorage < storage.length; iStorage++) {
                for (var iLocal = 0; iLocal < IDs.length; iLocal++) {
                    if (IDs[iLocal] === storage[iStorage]) {
                        storage.splice(iStorage, 1);
                    }
                }
            }
            _this.storageCareers = JSON.stringify(storage);
            _this.containerLoader.classList.remove('d-none');
            _this.containerItems.classList.add('d-none');
            localStorage.setItem('sbgCareersSaved', JSON.stringify(storage));
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
            _this.onload();
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// INIT
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSavedComponent.prototype.onload = function () {
        var _this = this;
        this.promiseInitial().then(function (response) {
            var data = [];
            response.map(function (item) {
                if (item.data) {
                    if (item.data.id) {
                        data.push(item.data);
                    }
                }
            });
            _this.buildLayout(data, _this.containerLoader, _this.containerItems, _this.containerEmpty, _this.containerButtons, _this.attributeDetailPage);
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// PROMISE
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerSavedComponent.prototype.promiseInitial = function () {
        var arrayServices = [];
        var parseStorage = JSON.parse(this.storageCareers);
        parseStorage.map(function (id) {
            var service = axios.get("https://api.smartrecruiters.com/v1/companies/StandardBankGroup/postings/" + id);
            arrayServices.push(service);
        });
        return Promise.all(arrayServices);
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// BUILD LAYOUT
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerSavedComponent.prototype.buildLayout = function (items, containerLoader, containerItems, containerEmpty, containerButtons, detailPageUrl) {
        if (items === void 0) { items = {}; }
        if (containerLoader === void 0) { containerLoader = undefined; }
        if (containerItems === void 0) { containerItems = undefined; }
        if (containerEmpty === void 0) { containerEmpty = undefined; }
        if (containerButtons === void 0) { containerButtons = undefined; }
        if (detailPageUrl === void 0) { detailPageUrl = ''; }
        // before completion
        containerItems.innerHTML = "";
        containerItems.classList.add('d-none');
        containerEmpty.classList.add('d-none');
        // more than 0 items
        if (items.length > 0) {
            // create items
            var output_1 = "";
            if (items.length > 0) {
                var content = items;
                content.map(function (item) {
                    // check values
                    var releasedDate = "";
                    var featured = "";
                    var name = "";
                    var location = "";
                    var segment = "";
                    var employmentType = "";
                    var description = "";
                    // checks
                    if (item.releasedDate) {
                        var getTodaysDate = new Date();
                        var getTodaysDay = getTodaysDate.getDate();
                        var systemDate = new Date(item.releasedDate);
                        var systemDay = systemDate.getDate();
                        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                        var systemDateFormatted = systemDate.getDate() + " " + monthNames[systemDate.getMonth()] + " " + systemDate.getFullYear();
                        var calculate = getTodaysDay - systemDay;
                        var dateFormatted = '';
                        switch (calculate) {
                            case 0:
                                dateFormatted = 'Posted today​';
                                break;
                            case 1:
                                dateFormatted = 'Posted 1 day ago';
                                break;
                            case 2:
                                dateFormatted = 'Posted 2 days ago';
                                break;
                            case 3:
                                dateFormatted = 'Posted 3 days ago';
                                break;
                            case 4:
                                dateFormatted = 'Posted 4 days ago';
                                break;
                            case 5:
                                dateFormatted = 'Posted 5 days ago';
                                break;
                            case 6:
                                dateFormatted = 'Posted 6 days ago';
                                break;
                            case 7:
                                dateFormatted = 'Posted 7 days ago';
                                break;
                            default:
                                dateFormatted = 'Posted ' + systemDateFormatted;
                        }
                        releasedDate = "<span class=\"career-search-component__item--date\">" + dateFormatted + "</span>";
                    }
                    if (item.department) {
                        if (item.department.id) {
                            var customLabel = item.department.label;
                            customLabel = customLabel.replace(' Job', '');
                            customLabel = customLabel.replace(' job', '');
                            customLabel = customLabel.replace(' JOB', '');
                            if (customLabel !== 'Standard') {
                                featured = "<span class=\"feature-badge career-search-component__item--badge\">\n\t\t\t\t\t\t\t\t\t" + customLabel + "\n\t\t\t\t\t\t\t\t</span>";
                            }
                        }
                    }
                    if (item.name) {
                        name = "<span class=\"career-search-component__item--title career-search-component__item--title__saved\">\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--title__checkbox\">\n\t\t\t\t\t\t\t\t<label class=\"form__control form__control--checkbox\">\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-selected-jobs\" value=\"" + item.id + "\">\n\t\t\t\t\t\t\t\t\t<span class=\"form__control-indicator\"></span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--title__text\">\n\t\t\t\t\t\t\t\t<h4 class=\"title title--module-sub-title \">\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t" + item.name + "\n\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</span>";
                    }
                    if (item.location) {
                        if (item.location.address) {
                            location += "" + item.location.address;
                        }
                        if (item.location.city) {
                            location += ", " + item.location.city;
                        }
                        if (item.location.region) {
                            location += ", " + item.location.region;
                        }
                        if (item.location.country) {
                            var countryUppercase = item.location.country;
                            location += ", " + countryUppercase.toUpperCase();
                        }
                    }
                    item.customField.map(function (customField) {
                        if (customField.fieldLabel === 'Business Segment') {
                            segment = customField.valueLabel;
                        }
                    });
                    if (item.typeOfEmployment) {
                        employmentType = item.typeOfEmployment.label;
                    }
                    output_1 += "<a href=\"" + detailPageUrl + "?jobID=" + item.id + "\" target=\"_blank\" class=\"career-search-component__item\" data-intent=\"informational\" data-scope=\"saved-jobs-listing\" data-id=\"link_content\" data-text=\"" + item.name + " link click\">\n\t\t\t\t\t\t" + featured + "\n\t\t\t\t\t\t" + name + "\n\t\t\t\t\t\t<span class=\"career-search-component__item--meta\">\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Location:</strong> " + location + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Business segment:</strong> " + segment + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Type of Employment:</strong> " + employmentType + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>";
                });
                containerItems.innerHTML = output_1;
            }
            // after completion
            containerLoader.classList.add('d-none');
            containerItems.classList.remove('d-none');
            containerButtons.classList.remove('d-none');
        }
        else {
            containerLoader.classList.add('d-none');
            containerButtons.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        }
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// DETECT CHECKBOXES
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerSavedComponent.prototype.detectCheckboxesSelected = function () {
        var selected = false;
        $('input.js-selected-jobs').each(function (index, item) {
            if ($(item).is(':checked')) {
                selected = true;
            }
        });
        if (selected) {
            this.containerButtonsSelected.classList.remove('d-none');
        }
        else {
            this.containerButtonsSelected.classList.add('d-none');
        }
    };
    return CareerSavedComponent;
}(Base));
export { CareerSavedComponent };



//////////////////
// WEBPACK FOOTER
// ./components-career/career-saved-component/career-saved-component.component.ts
// module id = 666
// module chunks = 0